import React, {useEffect, useState} from 'react'

const useShareUrl = (initialState = false) =>{

    const [showKopieMsg, setShowKopieMsg] = useState(initialState)

    useEffect(()=>{
        let timer1 = setTimeout(() => setShowKopieMsg(false), 2000);
        return () => {
            clearTimeout(timer1);
        };

    },[showKopieMsg])

    const handleDelen = (url) => {
        navigator.clipboard.writeText(url);
        setShowKopieMsg(true);
    }


    return [showKopieMsg, handleDelen]
}
export default useShareUrl